/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `BadgeState*`'s.
 */
export type BadgeState = BadgeStateAction | BadgeStateSuccess | BadgeStateInfo | BadgeStateWarning | BadgeStateDanger;

/**
 * The Badge action state type.
 */
export type BadgeStateAction = typeof BADGE_STATE_ACTION;

/**
 * The Badge success state type.
 */
export type BadgeStateSuccess = typeof BADGE_STATE_SUCCESS;

/**
 * The Badge informational state type.
 */
export type BadgeStateInfo = typeof BADGE_STATE_INFO;

/**
 * The Badge warning state type.
 */
export type BadgeStateWarning = typeof BADGE_STATE_WARNING;

/**
 * The Badge danger state type.
 */
export type BadgeStateDanger = typeof BADGE_STATE_DANGER;

/**
 * The Badge action state constant.
 */
export const BADGE_STATE_ACTION = `action`;

/**
 * The Badge success state constant.
 */
export const BADGE_STATE_SUCCESS = `success`;

/**
 * The Badge informational state constant.
 */
export const BADGE_STATE_INFO = `info`;

/**
 * The Badge warning state constant.
 */
export const BADGE_STATE_WARNING = `warning`;

/**
 * The Badge danger state constant.
 */
export const BADGE_STATE_DANGER = `danger`;
